import { useEffect, useState } from "react";
import { fetchManagerDashboard } from "PlatForms/OrgLMS/Services/ManagerService/ManagerDashboardService";
import api from "Common/Client/Interceptor";

const useManagerDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const managerId = localStorage.getItem("personalId");
        // Parent returns counts/profile only; the employees and trainings lists
        // were moved to separate paginated endpoints.
        const [data, employeesRes, trainingsRes] = await Promise.all([
          fetchManagerDashboard(token),
          api.get("/Learners/GetList-By-Manager", {
            params: { managerId, pageNumber: 1, pageSize: 10 },
          }),
          api.get("/Training/List-For-User", {
            params: { pageNumber: 1, pageSize: 10 },
          }),
        ]);
        setDashboardData({
          ...data,
          employees: employeesRes.data.items || [],
          trainings: trainingsRes.data.items || [],
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { dashboardData, loading, error };
};

export default useManagerDashboard;
